import { format, toZonedTime } from 'date-fns-tz';

// Helper function to determine the day suffix
const getDaySuffix = (day: number): string => {
  if (day >= 11 && day <= 13) return 'th';
  switch (day % 10) {
    case 1:
      return 'st';
    case 2:
      return 'nd';
    case 3:
      return 'rd';
    default:
      return 'th';
  }
};

// Main function to format date with time zone and dynamic day suffix
export const formatDate = (date: string, timeZone: string = 'UTC'): string => {
  const zonedDate = toZonedTime(new Date(date), timeZone);
  const day = format(zonedDate, 'd');
  const daySuffix = getDaySuffix(Number(day));
  return format(zonedDate, `MMMM d'${daySuffix},' yyyy`);
};
